module.exports = __webpack_public_path__ + "static/media/logo.e5974be9.svg";